<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/external_training_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "locales",
                "statitory_extension_period",
                "recommend_notify_period",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "area",
                "industry_categories",
                "system_class",
                "system_subclasses",
                "articles",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>